import * as React from 'react';

interface ITelephoneLink {
    id?: string;
    href?: string;
    alternativeText?: string;
    className?: string;
    children?: ChildNode;
}

const TelephoneLink = (props: ITelephoneLink) => {
    const stripCountryCode = (phoneNumber) => {
        if (phoneNumber && typeof phoneNumber === 'string' && phoneNumber.indexOf('+46') > -1) {
            return phoneNumber.replace('+46', '0');
        }

        /* TODO: Implement more country code replacements here in the future */

        return phoneNumber;
    };

    return (
        <span>
            <a
                href={'tel:' + (props.href ? props.href : props.children)}
                id={props.id}
                className={(props.className ? props.className + ' ' : '') + 'visible-xs visible-sm'}
            >
                {stripCountryCode(props.alternativeText ? props.alternativeText : props.children)}
            </a>
            <span className="hidden-xs hidden-sm">{stripCountryCode(props.children)}</span>
        </span>
    );
};

export default TelephoneLink;
